import { SSO } from "src/common/constants";
import { SSOLinkI } from "src/types/SSOLink";
import { SSOLinksAction } from "../reducers/ssoLinks";

export const SSO_SET_DATA = `${SSO}_SET_DATA` as const;

export const setSSOLinks = (payload: SSOLinkI[]): SSOLinksAction => ({
  type: SSO_SET_DATA,
  payload,
});
